var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketplaceIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.31 21.036h17.003a.938.938 0 00.9-.68l3.75-13.125a.938.938 0 00-.9-1.195H8.148l-.67-3.016a.938.938 0 00-.915-.734H.938a.937.937 0 100 1.875H5.81l3.384 15.232a2.817 2.817 0 00-1.695 2.58 2.816 2.816 0 002.813 2.813h17a.937.937 0 100-1.875h-17a.938.938 0 01-.002-1.875zM29.82 7.91l-3.215 11.25h-15.54l-2.5-11.25H29.82zM9.375 27.598a2.816 2.816 0 002.813 2.813A2.816 2.816 0 0015 27.598a2.816 2.816 0 00-2.813-2.812 2.816 2.816 0 00-2.812 2.812zm2.813-.937a.939.939 0 010 1.875.939.939 0 010-1.875zM22.625 27.598a2.816 2.816 0 002.813 2.813 2.816 2.816 0 002.812-2.813 2.816 2.816 0 00-2.813-2.812 2.816 2.816 0 00-2.812 2.812zm2.813-.937a.939.939 0 010 1.875.939.939 0 010-1.875z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/marketplace-industry.f647faeec92a0af8e69f8c2d682ec531.svg";
export { SvgMarketplaceIndustry as ReactComponent };